import { render } from "./WritingTestEndView.vue?vue&type=template&id=703581ad&lang=true"
import script from "./WritingTestEndView.vue?vue&type=script&lang=js"
export * from "./WritingTestEndView.vue?vue&type=script&lang=js"

import "./WritingTestEndView.vue?vue&type=style&index=0&id=703581ad&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__